// main.tsx
import "./index.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import i18n from "./core/libs/i18n/i18n.ts";

// Set HTML lang and dir based on language
const updateHtmlAttributes = (lng: string) => {
  const languageSettings = {
    fr: { lang: "fr", dir: "ltr" },
    en: { lang: "en", dir: "ltr" },
  } as const;

  const settings =
    languageSettings[lng as keyof typeof languageSettings] ||
    languageSettings.en;

  document.documentElement.setAttribute("lang", settings.lang);
  document.documentElement.setAttribute("dir", settings.dir);

  if (document.body) {
    document.body.setAttribute("dir", settings.dir);
  }
};


const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

let rendered = false;

const render = () => {
  if (rendered) return;
  rendered = true;
  ReactDOM.createRoot(rootEl).render(<App />);
};

// Render once i18n is ready, so the first paint won’t show raw keys.
i18n.on("initialized", () => {
  updateHtmlAttributes(i18n.language);
  render();
});

// Keep html attributes in sync when language changes (after app is mounted).
i18n.on("languageChanged", updateHtmlAttributes);

// Fast path (e.g., HMR or very fast init): if already initialized, render now.
if (i18n.isInitialized) {
  updateHtmlAttributes(i18n.language);
  render();
}
